import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams, RouterContext } from '~/types/router.type';

import {
  getInvoiceDetailQueryOptions,
  getInvoiceQueryOptions,
} from '~/data/invoice';

export const routeParams: RouteExportParams = {
  permissions: ['invoice_in.'],
  disablingFeatureFlag: FEATURE_FLAG.DISABLE_INVOICES,
};

export async function getInvoice({
  context,
  params,
}: {
  context: RouterContext;
  params: { invoiceId: string };
}) {
  const { invoiceId } = params;
  const { queryClient } = context;

  const { queryKey, queryFn } = getInvoiceQueryOptions({ invoiceId });

  const data = await queryClient.ensureQueryData({
    queryKey,
    queryFn,
  });

  return {
    ...context,
    pageData: {
      title: data?.invoiceNr ?? '',
    },
  };
}

export async function getInvoiceDetail({
  context,
  params,
}: {
  context: RouterContext;
  params: { invoiceId: string };
}) {
  const { invoiceId } = params;
  const { queryClient } = context;

  const data = await queryClient.ensureQueryData(
    getInvoiceDetailQueryOptions({ invoiceId }),
  );

  return {
    ...context,
    pageData: {
      title: data.data?.invoiceNumber ?? '',
    },
  };
}
